import * as React from 'react';
import { SingleKeyValueComponent, ComplexValue } from '../common/types';
import { getOptionsOrDefault } from '../common/code-table/get-options-or-default';
import { ButtonListButton } from './button-list-button';
import { InputControlContext } from '../common/input-control-context/input-control-context';
import styles from './button-list.scss';

export interface ButtonListProps extends SingleKeyValueComponent<number> {
  textNoData?: string;
  shouldTriggerValidation?: boolean;
  triggerValidation?: () => void;
}

export class ButtonList extends React.PureComponent<ButtonListProps, any> {

  public componentDidMount() {
    const {onLoadOptions, options} = this.props;
    const needsOptions = !options || !options.length;
    if (needsOptions && onLoadOptions) {
      this.props.onLoadOptions(undefined);
    }
  }

  private onChange = (value: ComplexValue<number>) => {
    const { onChange, shouldTriggerValidation, triggerValidation } = this.props;
    shouldTriggerValidation && triggerValidation && triggerValidation();
    onChange && onChange(value);
  };

  private renderOptions() {
    return getOptionsOrDefault(this.props.valueItem, this.props.options)
      .map((item, index) => item.value !== 0 ? this.renderItem(index, item, this.props.valueItem) : null);
  }

  private renderItem = (index: number, item: ComplexValue<number>, selectedOption?: ComplexValue<number>) => {
    return <ButtonListButton
        key={item.value || index}
        name={this.props.componentId}
        onChange={this.onChange}
        isSelected={selectedOption ? item.value === selectedOption.value : false}
        option={item} />;
  };

  public render() {
    const buttons = <div className={`${styles.statusSelector} btn-group grid-200`} data-toggle="buttons">
                      {this.renderOptions()}
                    </div>;
    const buttonsReadOnly = !!this.props.valueItem ?
                              <p className={styles.readOnlyText}>{this.props.valueItem.description}</p>
                              : <p className="no-content">{this.props.textNoData}</p>;
    return (
      <InputControlContext
        {...this.props as any}>
        {this.props.readOnly ? buttonsReadOnly : buttons}
      </InputControlContext>);
  }
}
